/**
 * LoginButton - An atom component for the login button in navigation.
 *
 * A simple button with Login icon and text.
 * Used in navigation bars and headers.
 */

import { LogIn } from 'lucide-react';
import { Button } from '@lean-agility/design-system/react';

export interface LoginButtonProps {
  /**
   * Callback invoked when the login button is clicked.
   */
  onLoginClicked: () => void;
  /**
   * Additional CSS classes.
   */
  className?: string;
}

export function LoginButton({ onLoginClicked, className }: LoginButtonProps) {
  return (
    <Button variant="outline" size="sm" onClick={onLoginClicked} className={className}>
      <LogIn className="size-4" />
      <span
        className="
          hidden
          sm:inline
        "
      >
        Login
      </span>
    </Button>
  );
}
